import React, { useEffect } from "react";
import {
  BrowserRouter,
  HashRouter,
  Redirect,
  Route,
  Switch,
  useLocation,
} from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { CloseButton, Fade } from "../components/common/Toast";
import ErrorLayout from "./ErrorLayout";
import { stringRandom } from "../helpers/stringRandom";
import { ProtectedRoute, RouteWithoutAuth } from "../helpers/ProtectedRoute";
import RootLayout from "./RootLayout";
import ProviderLayout from "./ProviderLayout";
import ProviderRegisterLayout from "../components/marketplace/provider/register/ProviderRegisterLayout";
import Faq from "../components/landing/pages/Faq";
import ServiceDetail from "../components/landing/pages/ServiceDetail";
import DashboardLayout from "./DashboardLayout";
import AuthLayout from "./AuthLayout";
import RegisterLayout from "../components/auth/register/WizardLayout";
import Landing from "../components/landing/Landing";
import Terms from "../components/landing/pages/Terms";
import Privacy from "../components/landing/pages/Privacy";
import AccountDeletion from "../components/landing/pages/AccountDeletion";
import AccountDeletionVerify from "../components/landing/pages/AccountDeletionVerify";

import PublicVisitorValidation from "../components/visitors/PublicVisitorValidation";
import WhatsappWidget from "../components/landing/WhatsappWidget";
import { MARKETPLACE_ENABLED } from "../helpers/marketplaceEnabled";

// HashRouter en el build de Electron: empaquetado no hay servidor que resuelva
// rutas limpias bajo file:///protocolo custom. El build web sigue con
// BrowserRouter (URLs limpias, importa para SEO y el link de QR de visitantes).
const Router = import.meta.env.MODE === "electron" ? HashRouter : BrowserRouter;

const Layout = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <Router>
      <Switch>
        <Route path="/v/:token" exact>
          <PublicVisitorValidation />
        </Route>
        <RouteWithoutAuth path="/authentication">
          <AuthLayout />
        </RouteWithoutAuth>
        {MARKETPLACE_ENABLED && (
          <RouteWithoutAuth path="/register/provider" exact>
            <ProviderRegisterLayout />
          </RouteWithoutAuth>
        )}
        <RouteWithoutAuth path="/register">
          <RegisterLayout />
        </RouteWithoutAuth>
        <ProtectedRoute
          rols={["manager", "property", "safety"]}
          path="/dashboard"
          key={stringRandom(3)}
          component={DashboardLayout}
        />
        <ProtectedRoute rols={["root"]} path="/root" key={stringRandom(3)}>
          <RootLayout />
        </ProtectedRoute>
        {MARKETPLACE_ENABLED && (
          <ProtectedRoute rols={["provider"]} path="/provider" key={stringRandom(3)}>
            <ProviderLayout />
          </ProtectedRoute>
        )}
        <Route path="/errors">
          <ErrorLayout />
        </Route>
        <Route path={"/faq"}>
          <div className={"container"}>
            <Faq />
          </div>
        </Route>
        <Route path={"/terms"}>
          <Terms />
        </Route>
        <Route path={"/privacy"}>
          <Privacy />
        </Route>
        {/* Formulario público de eliminación de cuenta: es la URL que se
            entrega a Google Play y App Store, y la que abre la app móvil. */}
        <Route path={"/account-deletion/verify/:token"} exact>
          <AccountDeletionVerify />
        </Route>
        <Route path={"/account-deletion"} exact>
          <AccountDeletion />
        </Route>
        <Route path={"/service/:id(\\d+)"}>
          <ServiceDetail />
        </Route>
        <Route component={Landing} />
      </Switch>
      <ToastContainer
        transition={Fade}
        closeButton={<CloseButton />}
        position={toast.POSITION.BOTTOM_LEFT}
        autoClose={true}
      />
      <WhatsappWidget />
    </Router>
  );
};

export default Layout;
